module.exports = __webpack_public_path__ + "static/media/caribe.5cf458b3.svg";